"use client";

import { useState } from "react";
import Link from "next/link";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import Image from "next/image";
import { IoSunnyOutline } from "react-icons/io5";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { F_TOKEN_STORE_KEY } from "@/constants/storage";
import { useRouter } from "next/navigation";
import { setUser } from "@/redux/slices/userSlice";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import FaImage from "../../image/FaImage";
import CommonImage from "@/components/common/image/CommonImage";
import { FaFacebookF, FaSearch } from "react-icons/fa";
import StudentTopNav from "./StudentTopNav";
import StudentNotifications from "./StudentNotifications";
import ThemeToggle from "../../darkMode/ThemeToggle";
import { usePathname } from "next/navigation";
import AuthMenuDrawer from "./components/drawer/AuthMenuDrawer";


export default function StudentAuthHeader({}) {
  const [isNotifyMenuOpen, setIsNotifyMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const dispatch = useDispatch();
  const router = useRouter();

  const logoutHandler = () => {
    router.push("/login");
    dispatch(setUser(null));
    Cookies.remove(F_TOKEN_STORE_KEY)
  };

  const userInfo = useSelector((state) => state.user.userInfo);
  const setting = useSelector((state) => state.setting.data);

  const [openMenu, setOpenMenu] = useState(null); // "profile" or "notification" or null

  const handleToggleProfile = () => {
    setOpenMenu((prev) => (prev === "profile" ? null : "profile"));
  };

  const handleToggleNotification = () => {
    setOpenMenu((prev) => (prev === "notification" ? null : "notification"));
  };

  return (
    <header className="header bg-fill-white">
      <div className="container">
        <div className="flex items-center justify-between h-16 md:h-20 relative">
          {/* Logo */}
          <Link
            href="/"
            className="flex items-center text-xl font-bold text-[#2e4e8d]"
          >
            <FaImage
              src={
                setting?.logo_light_url ??
                "/images/header-footer/main_logo_light.avif"
              }
              alt={"Main Logo"}
              className="max-w-[150px] h-[47px]"
              classes="[.dark_&]:hidden inline-block"
            />
            <FaImage
              src={
                setting?.logo_dark_url ??
                "/images/header-footer/main_logo_light.avif"
              }
              alt={"Main Logo"}
              className="max-w-[150px] h-[47px]"
               classes="hidden [.dark_&]:inline-block"
            />
          </Link>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-4">
              {userInfo ? (
                <>
                  <div className="student-profile-wrap relative">
                    <ThemeToggle />
                    <StudentNotifications
                      isOpen={openMenu === "notification"}
                      toggleMenu={handleToggleNotification}
                    />
                    <StudentTopNav
                      isOpen={openMenu === "profile"}
                      toggleMenu={handleToggleProfile}
                      logoutHandler={() => logoutHandler()}
                    />
                    <button
                      className="lg:hidden block mobile-menu-icon"
                      aria-label="Toggle menu"
                      onClick={toggleMenu}
                    >
                      {isMenuOpen ? (
                        <CloseOutlined style={{ fontSize: 20 }} />
                      ) : (
                        <MenuOutlined style={{ fontSize: 20 }} />
                      )}
                    </button>
                  </div>
                </>
              ) : (
                <button
                  className="login-reg-btn "
                  onClick={() => dispatch(openDrawer("login"))}
                >
                  <span className="login-btn">লগ ইন</span> /{" "}
                  <span className="reg-btn">রেজিস্টার</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <AuthMenuDrawer
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        userInfo={userInfo}
      />
    </header>
  );
}
